import { render, staticRenderFns } from "./ReviewsCategoriesColorTriadTableColumn.vue?vue&type=template&id=224535bb&scoped=true&"
import script from "./ReviewsCategoriesColorTriadTableColumn.vue?vue&type=script&lang=js&"
export * from "./ReviewsCategoriesColorTriadTableColumn.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsCategoriesColorTriadTableColumn.vue?vue&type=style&index=0&id=224535bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224535bb",
  null
  
)

export default component.exports